import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost/billing_system/backend/public/api',
  headers: { 'Accept': 'application/json' },
  // NOTE: withCredentials must be FALSE when using Bearer token auth.
  // Set it to true only when using Sanctum cookie-based sessions.
});

// ── Attach Bearer token to every request ─────────────────────────────────
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── Global response error handler ─────────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token expired / invalid → force re-login
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
